"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoTooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

var _DropdownMenu = require("../../molecules/DropdownMenu");

require("./InfoTooltip.css");

var _excluded = ["content", "buttonColor", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InfoTooltip = function InfoTooltip(_ref) {
  var content = _ref.content,
      buttonColor = _ref.buttonColor,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var cn = className ? "InfoTooltip ".concat(className) : "InfoTooltip";
  var dropdownElement = document.querySelector(".InfoTooltip .DropdownMenuContent");
  var videoPlayer = document.querySelector(".VideoPlayer");

  if (dropdownElement && videoPlayer) {
    videoPlayer.classList.add("active");
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({
    className: cn
  }, props), /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    className: "InfoTooltip",
    menuAlign: "center",
    classNameMenu: "dropdown",
    menuDirection: "bottom",
    menuPosition: "anchor",
    shouldCloseOnSelection: true,
    button: /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
      trkAction: "InfoTooltip Pressed",
      borderColor: "transparent-color",
      color: buttonColor,
      className: "button-tooltip-info",
      iconSize: 14,
      icon: _atoms.Icon.Type.Info
    })
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "tooltip-content"
  }, content)));
};

exports.InfoTooltip = InfoTooltip;